import { Divider } from "@hortis/ui/divider";
import { HoverCardContent } from "@hortis/ui/hover-card";
import { PhotoPlaceholder } from "@hortis/ui/photo-placeholder";
import { TwicImg } from "@twicpics/components/react";
import { AccessionFieldsFragment } from "generated/graphql";
import { AccessionViewProperties } from "src/features/records/accession/sections/accession-properties";
import { getRecordPhotos } from "src/features/taxonomy/components/taxon-page/header/get-record-photos";
import { twMerge } from "tailwind-merge";

export const AccessionHoverCardContent = ({
  accession,
}: { accession: AccessionFieldsFragment }) => {
  const { thumbnail } = getRecordPhotos(accession == null ? [] : [accession]);

  return (
    <HoverCardContent
      className={twMerge(
        "flex h-fit max-w-xs cursor-default gap-2 p-3 pb-4 shadow-xs flex-col",
      )}
      align="start"
      side="top"
    >
      <div className="flex items-center gap-3 pb-1">
        <div className="size-[44px] shrink-0">
          {thumbnail == null ? (
            <PhotoPlaceholder size="md" className="h-full w-full rounded-lg" />
          ) : (
            <TwicImg
              src={`${thumbnail.bucketName}/${thumbnail.fileName}`}
              eager
              focus="auto"
              mode="cover"
              className={twMerge(
                "h-[44px] overflow-hidden rounded-lg transition-transform hover:scale-[102%]",
                (accession.archived || accession.deaccessionDate != null) &&
                  "grayscale",
              )}
            />
          )}
        </div>
        <div className="truncate">
          <div className="font-semibold truncate text-grey-900 text-base">
            {accession?.accessionNumber}
          </div>
          <div className="text-sm font-medium text-grey-500">
            {accession?.scientificName}
          </div>
        </div>
      </div>
      <Divider />
      <div className="flex items-center gap-1 pt-1 truncate">
        <AccessionViewProperties accession={accession} />
      </div>
    </HoverCardContent>
  );
};
